// extracted by mini-css-extract-plugin
export default {"departments":"rF-z","departmentHeading":"sF-z","departmentSection":"tF-z","departmentName":"uF-z","departmentLink":"vF-z","expandIcon":"wF-z"};